export enum ActionConstants {
    SET_LATEST = 'SET_LATEST_REVIEW'
}
